import { render, staticRenderFns } from "./ObjectivesPanel.vue?vue&type=template&id=13dbf7ca"
import script from "./ObjectivesPanel.vue?vue&type=script&lang=js"
export * from "./ObjectivesPanel.vue?vue&type=script&lang=js"
import style0 from "./ObjectivesPanel.vue?vue&type=style&index=0&id=13dbf7ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports